// "Move to…" for a surface card (#1040/#1041): a native select of the
// surface's positions; choosing one moves the pack there, the unpinned
// packs between shifting along. A position a pin holds is offered disabled:
// pins stay where they are. Held at '' so it resets after each move.
export function PositionSelect({ pack, current = null, count, pinned = null, disabled, title, onMove }) {
  return (
    <select
      aria-label={`Move ${pack.title} to position`}
      value=""
      disabled={disabled}
      title={title}
      onChange={(event) => {
        const position = Number(event.target.value)
        if (position >= 1) onMove(position)
      }}
      className="rounded border border-[var(--prepacks-border)] bg-[var(--prepacks-bg)] px-1.5 py-0.5 text-[11px] text-[var(--prepacks-text)] disabled:opacity-30"
    >
      <option value="">Move to…</option>
      {Array.from({ length: count }, (_, index) => index + 1).filter((position) => position !== current).map((position) => <option key={position} value={position} disabled={Boolean(pinned?.has(position))}>#{position}{pinned?.has(position) ? ' (pinned)' : ''}</option>)}
    </select>
  )
}
